import { AfterViewInit, Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ColumnOrder } from '@core/table/order';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { MovimentacaoSocietariaService } from '@core/services/movimentacao-societaria.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-entidade-movimentacao-list',
  templateUrl: './entidade-movimentacao-list.component.html',
  styleUrls: ['./entidade-movimentacao-list.component.scss']
})
export class EntidadeMovimentacaoListComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() entidade: any;

  dataSet: any[] = [];
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;
  columOrder: ColumnOrder | undefined;
  nzFilterOption = (): boolean => true;

  constructor(private movimentacaoSocietariaService:MovimentacaoSocietariaService,
    private router: Router,

  ) { }

  ngAfterViewInit(): void {
    this.paginator.change.subscribe(() => {
      this.consultar();
    });
  }

  ngOnChanges(): void {
    if(this.entidade?.id) {
      this.consultar();
    }
  }

  ngOnInit() {
  }

  consultar(): void {
    if(!this.entidade?.id) {
      return;
    }
    this.movimentacaoSocietariaService.consultarIdDaEntidade(this.entidade.id, this.paginator.pagination).subscribe((data) => {
      this.dataSet = data.content;
      this.paginator.totalItens = data.totalElements;
    });
  }

  sort(event: any) {
    const itemSelected = event.sort.find((x: any) => x.value);
    const sortField = itemSelected?.key;
    const sortOrder = itemSelected?.value;

    const sortParams = {
      sortField,
      sortOrder
    };

    if(sortField && sortOrder) {
      this.loadData(sortParams);
    }
  }

  loadData(sortParams?: any): void {
    let params = {};
    if (sortParams) {
      params = { ...sortParams };
    }

    if(!this.entidade?.id) {
      return;
    }

    this.movimentacaoSocietariaService.consultarSortIdDaEntidade(this.entidade.id, this.paginator.pagination, params).subscribe((data) => {
      this.dataSet = data.content;
      this.paginator.totalItens = data.totalElements;
    });
  }

  editarMovimentacaoSocietaria(obj?: any, acao?: string): void {
    if(acao === 'visualizar') {
      this.router.navigate([`/movimentacao-societaria/mudanca-societaria/visualizar/${obj.id}`]);
      return;
    }else{
      this.router.navigate([`/movimentacao-societaria/mudanca-societaria/editar/${obj.id}`]);
    }
  }


}
